import React, { useState } from "react";
import { Button, Modal, Form, OverlayTrigger, Tooltip } from "react-bootstrap";
import { postData } from "../../../utils/api";

function OrderNoteButton({ orderId, note, onSaved }) {
  const [show, setShow] = useState(false);
  const [text, setText] = useState("");
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");

  const hasNote = !!(note && String(note).trim());

  const openModal = () => {
    setText(note || "");
    setError("");
    setShow(true);
  };

  const handleSave = async () => {
    setSaving(true);
    setError("");
    try {
      const res = await postData(
        `/admin/orders/product-order/note/${orderId}`,
        { notes: text },
      );
      if (res && res.success === false) {
        setError(res?.message || "Failed to save note");
        return;
      }
      setShow(false);
      if (onSaved) await onSaved();
    } catch (err) {
      console.error("Save note failed:", err);
      setError("Failed to save note");
    } finally {
      setSaving(false);
    }
  };

  const button = (
    <Button
      className="action-btn"
      onClick={openModal}
      style={
        hasNote
          ? { backgroundColor: "#dc3545", borderColor: "#dc3545", color: "#fff" }
          : undefined
      }
    >
      Note
    </Button>
  );

  return (
    <>
      {hasNote ? (
        <OverlayTrigger
          placement="top"
          overlay={
            <Tooltip id={`note-tip-${orderId}`}>
              <div style={{ whiteSpace: "pre-wrap", textAlign: "left" }}>
                {note}
              </div>
            </Tooltip>
          }
        >
          {button}
        </OverlayTrigger>
      ) : (
        button
      )}

      <Modal show={show} onHide={() => setShow(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>{hasNote ? "Edit Note" : "Add Note"}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Control
            as="textarea"
            rows={5}
            placeholder="Enter note for this order"
            value={text}
            onChange={(e) => setText(e.target.value)}
          />
          {error && <p className="text-danger mt-2 mb-0">{error}</p>}
        </Modal.Body>
        <Modal.Footer className="justify-content-center">
          <Button variant="secondary" onClick={() => setShow(false)}>
            Cancel
          </Button>
          <Button variant="primary" onClick={handleSave} disabled={saving}>
            {saving ? "Saving..." : "Save"}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default OrderNoteButton;